import { api, unwrap } from "../lib/axios";
import type { ApiEnvelope } from "../types/api";
import type { Admin, LoginResult } from "../types/admin";

export const authApi = {
  async login(email: string, password: string): Promise<LoginResult> {
    const res = await api.post<ApiEnvelope<LoginResult>>("/auth/admin/login", {
      email,
      password,
    });
    return unwrap(res);
  },

  async profile(): Promise<{ admin: Admin }> {
    const res = await api.get<ApiEnvelope<{ admin: Admin }>>(
      "/auth/admin/profile",
    );
    return unwrap(res);
  },

  async updatePassword(
    currentPassword: string,
    newPassword: string,
  ): Promise<void> {
    await api.put("/auth/admin/update-password", {
      currentPassword,
      newPassword,
    });
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post("/auth/admin/forgot-password", { email });
  },

  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post("/auth/admin/reset-password", { token, newPassword });
  },

  async logout(): Promise<void> {
    // Best-effort server-side invalidation; local clear happens regardless.
    try {
      await api.post("/auth/admin/logout");
    } catch {
      /* ignore */
    }
  },
};
